import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Mail } from "lucide-react";
import logoWhite from "@/assets/logo-white.svg";

export const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <footer
      data-testid="footer"
      ref={ref}
      className="py-16 bg-[#2C2C2C]"
    >
      <div className="max-w-screen-xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
          className="flex flex-col items-center gap-8"
        >
          <a href="/" className="block">
            <img
              src={logoWhite}
              alt="alongside.one"
              className="h-10 w-auto opacity-80 hover:opacity-100 transition-opacity"
            />
          </a>

          <div className="flex flex-col items-center gap-2">
            <p className="font-sans text-xs text-[#F5ECD7]/30">
              Real humans. Real connection.
            </p>
            <a
              href="mailto:human@alongside.one"
              data-testid="footer-email"
              className="font-sans text-xs text-[#F5ECD7]/30 hover:text-[#E8A838] transition-colors"
            >
              human@alongside.one
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
